import { render, staticRenderFns } from "./m-select.vue?vue&type=template&id=28e10792&scoped=true"
import script from "./m-select.vue?vue&type=script&lang=js"
export * from "./m-select.vue?vue&type=script&lang=js"
import style0 from "./m-select.vue?vue&type=style&index=0&id=28e10792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e10792",
  null
  
)

export default component.exports